export default function () {

  const wpcf7Elm = document.querySelector('.wpcf7');

  wpcf7Elm.addEventListener('wpcf7mailsent', function (event) {
    // $('.wpcf7-form .cust-row').css('opacity', 0);
    // $('.wpcf7-form .cust-row input').attr('readonly');
    // $('.wpcf7-form .cust-row').css('visiblity', 'none');
    $('.wpcf7-response-output').addClass('white-color font-bold');
    $('.wpcf7-response-output').css({ border: 0, padding: '0 0 10px 0', margin: 0 });
  }, false);
}
